import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyCart: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div>
            <p>{t("Your cart is empty.")}</p>
        </div>
    );
};

export default EmptyCart;